import { css } from 'linaria';

export const suggestionsFieldset = css`
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
`;

export const suggestionsWrapper = css`
  display: flex;
  flex-direction: column;
  @media (--only-mobile) {
    max-width: 100dvw;
  }

  &.dividers {
    position: relative;
    margin: var(--space-100) 0;
    padding: var(--space-100) 0;

    &::before {
      position: absolute;
      top: 0;
      left: var(--space-900);
      display: block;
      width: calc(100% + var(--space-400));
      border-top: 1px solid var(--control-minor);
      content: '';
    }

    &::after {
      position: absolute;
      bottom: 0;
      left: var(--space-900);
      display: block;
      width: calc(100% + var(--space-400));
      border-bottom: 1px solid var(--control-minor);
      content: '';
    }
  }
`;
